import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'registries';

export function useGetAllRegistries(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetRegistry(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateRegistry() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateRegistry({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteRegistry({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
